
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ProductNew.css";
import { Link } from "react-router-dom";

const products = [
  {
    title: "Global Port Management System",
    description:
      "Managing terminal operations in the maritime industry demands efficiency.",
    image: "product-img/crane.png",
    iconClass: "service-marketicon",
    boxClass: "box-mb",
  },
  {
    title: "Global iParking Management System",
    description:
      "Parking management in urban areas and commercial centers presents significant challenges in terms of efficiency.",
    image: "product-img/parking.png",
    iconClass: "service-producticon",
    boxClass: "box-mb",
    top: true,
  },
  {
    title: "Global Toll Plaza Management System",
    description:
      "Efficient toll plaza management is crucial for ensuring smooth traffic flow.",
    image: "product-img/barrier.png",
    iconClass: "service-designicon",
  },
  {
    title: "Global iFile Management System",
    description:
      "Efficient document management is critical for organizational productivity and compliance.",
    image: "product-img/computer.png",
    iconClass: "service-dataicon",
    top: true,
  },
];

const productFeatures = [
  "Global Port Management System",
  "Global iParking Management System",
  "Global Toll Plaza Management System",
  "Global iFile Management System",
];

function ProductNew() {

  // AOS Initialization
 useEffect(() => {
  AOS.init({
    duration: 1000,
    delay: 100,
    once: false,       // Har baar animation chalegi
    mirror: true,      // Scroll up/down par animation trigger hogi
    offset: 100,
    easing: "ease-in-out",
    anchorPlacement: "top-bottom",
  });

  AOS.refreshHard();

  return () => {
    AOS.refresh();
  };
}, []);

  return (
    <section className="service-section bgbluehome1 bgimgpro">

      {/* Background Layers */}
      <figure
        className="service-leftlayer mb-0"
        data-aos="fade-right"
        data-aos-duration="1200"
      >
        <img
          src="product-img/service-leftlayer.png"
          alt=""
          className="img-fluid"
        />
      </figure>

      <figure
        className="service-dotimage mb-0"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <img
          src="product-img/service-dotimage.png"
          alt=""
          className="img-fluid"
        />
      </figure>

      <div className="container">
        <div className="row align-items-center">

          {/* LEFT SIDE - PRODUCT CARDS */}
          <div
            className="col-lg-6 col-md-12 col-sm-12 col-12"
            data-aos="fade-right"
            data-aos-duration="1100"
          >
            <div className="service_contentbox">

              {/* First Row */}
              <div className="row">

                {products.slice(0, 2).map((product, index) => (
                  <div
                    className="col-lg-6 col-md-6 col-sm-6 col-12"
                    key={product.title}
                    data-aos={index === 0 ? "fade-up" : "fade-up"}
                    data-aos-delay={index * 200}
                    data-aos-duration="1000"
                  >
                    <div className={product.top ? "box-top" : ""}>

                      <div className={`service-box ${product.boxClass || ""}`}>

                        <figure className={product.iconClass}>
                          <img
                            src={product.image}
                            alt={product.title}
                            className="img-fluid"
                          />
                        </figure>

                        <h4 className="rajfont">
                          {product.title}
                        </h4>

                        <p className="text-size-18">
                          {product.description}
                        </p>

                        <Link to="/product-page">
                          <i className="circle fa-thin fa-arrow-right"></i>
                        </Link>

                      </div>
                    </div>
                  </div>
                ))}

              </div>

              {/* Second Row */}
              <div className="row">

                {products.slice(2, 4).map((product, index) => (
                  <div
                    className="col-lg-6 col-md-6 col-sm-6 col-12"
                    key={product.title}
                    data-aos="fade-up"
                    data-aos-delay={300 + index * 200}
                    data-aos-duration="1100"
                  >
                    <div className={product.top ? "box-top" : ""}>

                      <div className="service-box">

                        <figure className={product.iconClass}>
                          <img
                            src={product.image}
                            alt={product.title}
                            className="img-fluid"
                          />
                        </figure>

                        <h4 className="rajfont">
                          {product.title}
                        </h4>

                        <p className="text-size-18">
                          {product.description}
                        </p>

                        <Link to="/product-page">
                          <i className="circle fa-thin fa-arrow-right"></i>
                        </Link>

                      </div>
                    </div>
                  </div>
                ))}

              </div>

            </div>
          </div>

          {/* RIGHT SIDE - PRODUCT CONTENT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">

            <div className="service_content position-relative">

              {/* Right Circle Image */}
              <figure
                className="service-rightcircle mb-0"
                data-aos="zoom-in"
                data-aos-duration="1200"
              >
                <img
                  src="ImagesNew/image_svg1.png"
                  alt=""
                  className="img-fluid img_svg"
                />
              </figure>

              {/* Heading */}
              <h3
                className="our-products-heading"
                data-aos="fade-down"
                data-aos-duration="1000"
              >
                <strong>Our Products</strong>
              </h3>

              {/* Main Title */}
              <h2
                className="produh2"
                data-aos="fade-up"
                data-aos-delay="200"
                data-aos-duration="1000"
              >
                BEST IT SOLUTION FOR YOUR BUSINESS
              </h2>

              {/* Description */}
              <p
                className="produp"
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1000"
              >
                We deliver innovative, reliable, and scalable IT solutions
                designed to simplify business operations. Our advanced
                management systems help organizations improve efficiency,
                streamline processes, and achieve better operational control.
              </p>

              {/* Product Heading */}
              <h4
                className="Ourprod"
                data-aos="fade-right"
                data-aos-delay="300"
              >
                Our Products:
              </h4>

              {/* Product Features */}
              <div className="productfeature">

                {productFeatures.map((feature, index) => (
                  <span
                    className="pillar-tag"
                    key={feature}
                    data-aos="fade-left"
                    data-aos-delay={350 + index * 150}
                    data-aos-duration="900"
                    style={{
                      animationDelay: `${0.1 + index * 0.2}s`,
                    }}
                  >
                    ✔ {feature}.
                  </span>
                ))}

              </div>

              {/* Read More Button */}
              <div
                className="get_started text-white"
                data-aos="zoom-in"
                data-aos-delay="500"
                data-aos-duration="1000"
              >
                <Link to="/product-page">
                  Read More
                </Link>

                <figure className="mb-0">
                  <img
                    src="product-img/button-arrow.png"
                    alt=""
                    className="img-fluid"
                  />
                </figure>
              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Right Background Layer */}
      <figure
        className="service-rightlayer mb-0"
        data-aos="fade-left"
        data-aos-duration="1200"
      >
        <img
          src="product-img/service-rightlayer.png"
          alt=""
          className="img-fluid"
        />
      </figure>

    </section>
  );
}

export default ProductNew;
